module.exports = __webpack_public_path__ + "media/numbers/one-dd3ad914.svg";